import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { marginLeft, marginRight } from 'utils';

export const StyledRelativeDateTime = styled('span')(
  () => css`
    font-size: 0.75rem;
    color: #4c6fff;
    .icon {
      ${marginLeft('6px')}
    }
    .from-now {
      font-weight: 700;
      white-space: nowrap;
    }
  `
);

export const StyledNormalDateTime = styled('span')(
  () => css`
    font-size: 0.75rem;
    color: #aaa;
    .icon {
      ${marginLeft('6px')}
    }
    .date-container {
      ${marginLeft('12px')}
      ${marginRight('16px')}
    }

    &.tooltip {
      color: #0f5e62;
      .icon {
        color: #0f5e62;
      }
    }
  `
);
